/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgHifiIcon } from "../shared/SvgHifiIcon";
var CheckHifiIcon = function CheckHifiIcon(props) {
  return /*#__PURE__*/React.createElement(SvgHifiIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 24C7 14.6112 14.6112 7 24 7C33.3888 7 41 14.6112 41 24C41 33.3888 33.3888 41 24 41C14.6112 41 7 33.3888 7 24ZM24 5C13.5066 5 5 13.5066 5 24C5 34.4934 13.5066 43 24 43C34.4934 43 43 34.4934 43 24C43 13.5066 34.4934 5 24 5ZM21.4934 27.0793L16.9999 22.5858L15.5857 24L20.7863 29.2006C21.1768 29.5911 21.81 29.5911 22.2005 29.2006L32.2846 19.1165L30.8704 17.7023L21.4934 27.0793Z"
  }));
};
export default CheckHifiIcon;